import testIds from './testIds';

type Props = {
  gtmId?: string;
};

const GoogleTagManagerNoScript = ({ gtmId }: Props) => {
  return (
    <noscript>
      {/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
        height="0"
        width="0"
        style={{ display: 'none', visibility: 'hidden' }}
        data-testid={testIds.productionTag}
      />
    </noscript>
  );
};

export default GoogleTagManagerNoScript;
